import { defineComponent as _defineComponent } from 'vue'
import {
  TUIStore,
  StoreName,
  TUIConversationService,
} from "@tencentcloud/chat-uikit-engine";
import { ref, onMounted } from "../../adapter-vue";
import ConversationList from "./conversation-list/index.vue";
import ConversationHeader from "./conversation-header/index.vue";
import ConversationNetwork from "./conversation-network/index.vue";
import { getdetail } from "@/api";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["handleSwitchConversation", "getconversationList"],
  setup(__props, { emit: emits }) {

const isOfficial = ref(false);


const totalUnreadCount = ref(0);
const headerRef = ref<typeof ConversationHeader>();
const isShowConversationHeader = ref<boolean>(false);
const mes = ref("");
const count = ref(0);
onMounted(() => {
  getdetail({}).then((res) => {
    mes.value = res.data[1].message;
    count.value = res.data[1].count;
  });
});
TUIStore.watch(StoreName.CONV, {
  totalUnreadCount: (count: number) => {
    totalUnreadCount.value = count;
  },
  currentConversationID: (id) => {
    isOfficial.value = id ? false : true;
  },
});

// TUIStore.watch(StoreName.CUSTOM, {
//   isShowConversationHeader: (showStatus: boolean) => {
//     isShowConversationHeader.value = showStatus !== false;
//   },
// });

const handleSwitchConversation = (conversationID: string) => {
  emits("handleSwitchConversation", conversationID);
};
const getconversationList = (list: Object) => {
  emits("getconversationList", list);
};
const handleClickConv = () => {
  headerRef?.value?.closeChildren();
};
const notice = () => {
  // 退出聊天界面
  TUIConversationService.switchConversation("");
};

return { __sfc: true,isOfficial, emits, totalUnreadCount, headerRef, isShowConversationHeader, mes, count, handleSwitchConversation, getconversationList, handleClickConv, notice, ConversationList, ConversationHeader, ConversationNetwork }
}

})